import { NumberOutlined } from '@ant-design/icons';
import { gql } from '@apollo/client';
import { Form, Input } from 'antd';
import Modal from 'components/Modal';
import PhoneNumber from 'components/PhoneNumber';
import { useMutation } from 'hooks/apollo';
import React, { useEffect, useState } from 'react';

const ENABLE_MFA = gql`
  mutation($userId: ID!, $mfaCode: String) {
    enableMfa(userId: $userId, mfaCode: $mfaCode) {
      id
      mfa
    }
  }
`;

const EnableMFA = ({ user, onCancel }) => {
  const [enableMfa, { loading }] = useMutation(ENABLE_MFA);
  const [codeSent, setCodeSent] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setCodeSent(false);
    form.resetFields();
  }, [user]);

  const okText = codeSent ? 'Verify' : 'Send verification code';

  const handleOk = async () => {
    if (codeSent) {
      form.submit();
    } else {
      await enableMfa({ variables: { userId: user.id } });
      setCodeSent(true);
    }
  };

  const handleSubmit = async (values) => {
    try {
      await enableMfa({ variables: { userId: user.id, mfaCode: values.mfaCode } });
      onCancel();
    } catch (e) {
      form.setFields([{ name: 'mfaCode', errors: ['Invalid verification code'] }]);
    }
  };

  return (
    <Modal title="Enable SMS verification" open={!!user} onCancel={onCancel} okText={okText} onOk={handleOk} confirmLoading={loading}>
      <p>SMS verification adds an extra layer of security to your account and protects against unauthorized access.</p>
      <p>
        To enable it we need to verify your phone number, send a code to
        <PhoneNumber number={user?.phone} />
      </p>

      {codeSent && (
        <Form form={form} layout="vertical" onFinish={handleSubmit} validateTrigger="onSubmit">
          <Form.Item name="mfaCode" label="Verification code" rules={[{ required: true, len: 6, message: '6 digit code is required' }]}>
            <Input
              prefix={<NumberOutlined className="input-icon" />}
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default EnableMFA;
